import React from 'react'

import {PipelineChart} from '../../components/common/PipelineChart/PipelineChart'
import type {pipelineHeadFragment$key} from '../../hooks/__generated__/pipelineHeadFragment.graphql'
import {
  useJobId,
  usePipelineExistingJobIdsSet,
  usePipelineDraftGraph,
} from '../EditPipelinePage.hooks'

import AddJob from './AddJob/AddJob'
import JobTile from './JobTile/JobTile'

const NODE_HEIGHT = 88
const NODE_WIDTH = 204

type Props = {pipelineHeadKey: pipelineHeadFragment$key | null}

function EditPipelineChart({pipelineHeadKey}: Props) {
  const selectedJob = useJobId()

  const existingJobIds = usePipelineExistingJobIdsSet()
  const graph = usePipelineDraftGraph()

  return (
    <>
      <PipelineChart
        graph={graph}
        nodeWidth={NODE_WIDTH}
        nodeHeight={NODE_HEIGHT}
        pointOffsetY={14}
        renderJob={node => {
          const {id} = node.data
          return (
            <JobTile
              x={node.y! - NODE_WIDTH / 2}
              y={node.x! - NODE_HEIGHT / 2}
              selected={selectedJob === id}
              isNew={!existingJobIds.has(id)}
              key={id}
              id={id}
              pipelineHeadKey={pipelineHeadKey}
            />
          )
        }}
      />
      <AddJob jobCount={Object.keys(graph).length} />
    </>
  )
}

export default EditPipelineChart
